import {Keyable} from "@/types/keyable.type";

export class ApiPlatformParser {
    static LIST_TYPE = 'list'

    response: Keyable
    type: string

    constructor(response: object, type: string) {
        this.response = response
        this.type = type
    }

    getData(): []{
        if(this.type === 'list') {
          return this.response['member']
        }
        return []
    }

    getPageSize(): number {
        const lastPage = this.response['view']['last']
        if(!lastPage) return 1
        const split = lastPage.split('=')
        return parseInt(split[split.length - 1])
    }

    getTotalItemCount(): number {
        return this.response['totalItems']
    }
}